export const CONTENT_TYPE_QUEST = "CONTENT_TYPE_QUEST";
export const CONTENT_TYPE_GIG = "CONTENT_TYPE_GIG";

export const QUEST_BY_USER_WIP = "QUEST_BY_USER_WIP";

export const QUEST_SCREEN_SET = "QUEST_SCREEN_SET";
export const QUEST_SCREEN_SET_DEADLINE = "QUEST_SCREEN_SET_DEADLINE";
export const QUEST_SCREEN_POST = "QUEST_SCREEN_POST";
export const QUEST_SCREEN_ERROR_OCCURRED = "QUEST_SCREEN_ERROR_OCCURRED";

export const QUEST_ACTION_REQUEST = "QUEST_ACTION_REQUEST";
export const QUEST_CREATE_SUCCESS = "QUEST_CREATE_SUCCESS";
export const QUEST_CREATE_FAILURE = "QUEST_CREATE_FAILURE";
export const QUEST_UPDATE_SUCCESS = "QUEST_UPDATE_SUCCESS";
export const QUEST_UPDATE_FAILURE = "QUEST_UPDATE_FAILURE";

export const QUEST_SCREEN_UPDATE = "QUEST_SCREEN_UPDATE";
export const QUEST_LINK_UPDATE = "QUEST_LINK_UPDATE";

export const ACTIVATE_START_A_QUEST = "ACTIVATE_START_A_QUEST";
export const DEACTIVATE_START_A_QUEST = "DEACTIVATE_START_A_QUEST";
export const UPDATE_START_A_QUEST_PAYLOAD = "UPDATE_START_A_QUEST_PAYLOAD";
